module.exports = __webpack_public_path__ + "static/img/kjdy9.ab07ae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy9.png
// module id = 344
// module chunks = 0